module.exports = __webpack_public_path__ + "img/28.d087bab3.jpg";